var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2 ml-2 mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.makeWeaponPDF()}}},[_vm._v(" PDF "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-file-pdf-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }